<template>
<div class="recharge_left capital_first">
    <div class="perfect_content">
        <div class="content_title">Gxpay</div>
        <div class="content_table">
            <table border="0" cellspacing="0" cellpadding="0">
                <tr>
                    <td>
                        <div>Gxpay 账号</div>
                        <div class="textMargin">{{ gxpay_account }}</div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div>Gxpay ID</div>
                        <div class="textMargin">{{ gxpay_id }}</div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div>Gxpay 余额
                        </div>
                        <div class="textMargin">{{ gxpay_balance }}</div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div>买币
                        </div>
                        <div class="textMargin url" @click="openBuyUrl()"><i class="el-icon-arrow-right"></i></div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div>卖币
                        </div>
                        <div class="textMargin url" @click="openSellUrl()"><i class="el-icon-arrow-right"></i></div>
                    </td>
                </tr>
                <tr>
                    <td style="border: none;">
                        <div>我的订单
                        </div>
                        <div class="textMargin url" @click="openOrderListUrl()"><i class="el-icon-arrow-right"></i></div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <el-card class="box-card">
        <div v-html="gxpayContentDescription" style="padding:20px 20px 20px 80px"></div>
    </el-card>
</div>
</template>

    
<script>
export default {
    name: "gxpay",
    data() {
        return {
            gxpay_account: '',
            gxpay_id: '',
            gxpay_balance: '',
            buyUrl: '',
            sellUrl: '',
            orderListUrl: '',
            gxpayContentDescription: ''
        };
    },
    mounted: function () {
        this.getGxpayDigitalCurrency();
        this.gxpayContentDesc();
    },
    methods: {
        getGxpayDigitalCurrency() {
            let that = this;
            that
                .$http({
                    url: "/",
                    method: "POST",
                    data: {
                        nozzle: "gxpay_thirdparty_digital_currency",
                        token: sessionStorage.getItem("token"),
                    },
                })
                .then((ret) => {
                    let resData = ret.data;
                    if (resData.code == 1) {
                        that.gxpay_account = resData.data.account;
                        that.gxpay_id = resData.data.numberId;
                        that.gxpay_balance = resData.data.walletDTOList.length > 0 ? resData.data.walletDTOList[0]['money'] : 0;
                        that.buyUrl = resData.data.buyUrl;
                        that.sellUrl = resData.data.sellUrl;
                        that.orderListUrl = resData.data.orderListUrl;

                    }
                });
        },
        openBuyUrl() {
            window.open(this.buyUrl);
        },
        openSellUrl() {
            window.open(this.sellUrl);
        },
        openOrderListUrl() {
            window.open(this.orderListUrl);
        },
        gxpayContentDesc() {
            let that = this;
            that
                .$http({
                    url: "/",
                    method: "post",
                    data: {
                        nozzle: "sysconfig",
                        token: sessionStorage.getItem("token"),
                        name: "gxpay_desc",
                    },
                })
                .then(function (res) {
                    if (res.data.code == 1) {
                        that.gxpayContentDescription = res.data.data;
                    } else if (res.data.code === 0 || res.data.code === -1) {
                        that.$toast.fail(res.data.msg);
                    }
                });
        }
    }
};
</script>

    
<style scoped>
.perfect_content {
    width: 1000px;
    margin: 20px auto 0;
    border: 1px solid #eee;
}

.content_title {
    height: 80px;
    line-height: 100px;
    font-size: 20px;
    text-align: left;
    margin-left: 20px;
}

.content_table {
    margin-bottom: 40px;
}

.content_table table {
    width: 924px;
    margin: 0 auto;
    /* height: 310px; */
    margin-bottom: 40px;
    border: 1px solid #ccc;
}

.content_table table tr td:nth-child(1) {
    width: 648px;
    height: 55px;
    overflow: hidden;
    background-color: white;
    border-bottom: 1px solid #ccc;
}

.content_table table tr td:nth-child(1) div:nth-child(1) {
    float: left;
    margin-left: 60px;
    font-size: 14px;
}

.textMargin {
    margin-left: 30px;
    float: right;
    margin-right: 60px;
    font-size: 14px;
}

.url {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/gxpay.vue